import React from 'react'
import PropTypes from 'prop-types'

import { TextContainer } from './styled'

import { h2 } from './const'

const H2 = ({
  className,
  color,
  children,
  bold,
  align,
  transform,
  ...props
}) => {
  const { size, lineHeight, element } = h2
  const fontWeight = bold ? 500 : 300
  const Container = TextContainer(element)
  return (
    <Container
      className={className}
      bold={bold}
      size={size}
      lineHeight={lineHeight}
      fontWeight={fontWeight}
      color={color}
      align={align}
      transform={transform}
      {...props}
    >
      {children}
    </Container>
  )
}

H2.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  bold: PropTypes.bool,
  align: PropTypes.string,
  transform: PropTypes.string,
}

export default H2
